import {
  RevisionHistoryActionButton,
  RevisionHistoryActionContext
} from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';
import { DeleteRevisionAction } from '~src/revisionHistory/services/DeleteRevisionAction';
import { RevisionActions } from '~src/revisionHistory/services/RevisionActions';

import { FlowRevision } from '../serverApi/types/FlowRevision';


export namespace RevisionActionFlow {
  export function getFlowRevisionActionButtons(): RevisionHistoryActionButton<FlowRevision>[] {
    return [
      deleteFlowRevisionAction(),
      RevisionActions.downloadContentRevisionAction()
    ];
  }

  // action button factories
  function deleteFlowRevisionAction(): RevisionHistoryActionButton<FlowRevision> {
    return {
      name: 'delete',
      translate: 'delete_action',
      execute: (context: RevisionHistoryActionContext<FlowRevision>) => {
        DeleteRevisionAction.showDeleteFlowRevisionDialog(context.selectedItem, context);
      }
    };
  }
}
